<template>
  <div>
    <v-data-table
      hide-default-header
      hide-default-footer
      :headers="headers"
      :items="errorList"
      :options="{ itemsPerPage: 999 }"
    >
      <template v-slot:item.error="{ item }">
        <span>{{ decodeHtml(getItemError(item)) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'LocaleErrorTable',

  props: {
    errorList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      headers: [
        {
          text: this.$t('views.shipment_notice_list.asn_shipping_errors'),
          value: 'error',
        },
      ],
    };
  },
  methods: {
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    getItemError(item) {
      if (!item) return this.$t('views.shipment_notice_list.asn_invalid_error_structure');

      return item[this.$i18n.locale]
        || item.en
        || this.$t('views.shipment_notice_list.asn_invalid_error_structure');
    },
  },
};
</script>

<style scoped>

</style>
